export default {
  show: true,
  title:
    "What’s new: Integrations Update, Connection Builder, Custom Parameters in Rule’s Push Payloads, and more.",
  link: {
    href: "https://apphud.com/blog/products-updates-april-2025",
    title: "Let’s see",
  },
};
